import React from "react";
import { Box, UnstyledButton } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { StaffFace } from "../grid/StaffFace";
import styles from "./ProviderOptionList.module.css";

export interface ProviderOption {
  id: string;
  name: string;
  initials: string;
  photo?: string | null;
}

export interface ProviderOptionListProps {
  options: ProviderOption[];
  /** The current provider (highlighted, with a check). */
  selectedId: string | null;
  onPick: (id: string) => void;
}

/**
 * Provider rows (design 2.5): 46px rows with a photo / initials avatar, the
 * name, and a check on the current provider. Shared by the reschedule
 * section's full-cover picker and the week view's provider sheet.
 */
export const ProviderOptionList: React.FC<ProviderOptionListProps> = ({
  options,
  selectedId,
  onPick,
}) => (
  <>
    {options.map((o) => {
      const on = o.id === selectedId;
      return (
        <UnstyledButton
          key={o.id}
          className={styles.pickRow}
          data-on={on}
          aria-pressed={on}
          onClick={() => onPick(o.id)}
          data-testid={`provider-option-${o.id}`}
        >
          <Box component="span" className={styles.pickAvatar}>
            <StaffFace photo={o.photo} initials={o.initials} />
          </Box>
          <Box component="span" className={styles.pickName}>
            {o.name}
          </Box>
          {on && (
            <Box component="span" className={styles.pickTick}>
              <IconCheck size={15} stroke={1.8} />
            </Box>
          )}
        </UnstyledButton>
      );
    })}
  </>
);
